import *  as ActionTypes from './actionTypes';
import httpRequestMethods from "../lib/httpRequestMethods";
import LocalStorageWrapper from "../lib/localStorageWrapper";
import { LOGOUT } from "./actionTypes";
import { getCurrentUser } from "./currentUserProfileActions";
import { getCurrentUserRoles } from "./currentUserRolesActions";

const requestLogin = () => ({
    type: ActionTypes.LOGIN_REQUEST,
    isFetching: true,
});

const receiveLogin = (accessToken) => ({
    type: ActionTypes.LOGIN_SUCCESS,
    accessToken,
    isFetching: false,
});

const rejectLogin = (message) => ({
    type: ActionTypes.LOGIN_FAILURE,
    message,
    isFetching: false,
});

const authenticate = async (username, password) => {

    const config = {
        method: httpRequestMethods.POST,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password&client_id=1af9339e-2f1f-4963-8c00-c7093471b48f`
    };

    try {
        const response = await fetch(`${process.env.REACT_APP_AUTH_HOST}oauth2/token`, config);
        const json = await response.json();

        if (!response.ok) {
            return Promise.reject(json.error_description);
        }

        LocalStorageWrapper.setItem('accessToken', json.access_token);

        return json.access_token;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const login = (username, password) => {
    return async (dispatch) => {
        dispatch(requestLogin());
        try {
            const accessToken = await authenticate(username, password);

            await Promise.all([
                dispatch(getCurrentUser()),
                dispatch(getCurrentUserRoles())
            ]);

            return dispatch(receiveLogin(accessToken));
        } catch (error) {
            return dispatch(rejectLogin('Username or password is incorrect'));
        }
    };
};

export const logout = () => {
    LocalStorageWrapper.clear();
    return {
        type: LOGOUT,
    };
};